import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { addNotification } from 'actions/NotificationsActions';
import LoaderCC from '../LoaderCC';
import EntityPropsUpdater from '../../../component/EntityPropsUpdater';

class LeadContentCheck extends EntityPropsUpdater {
  constructor(props) {
    super(props);
    this.state = {
      createdOrUploadedPDF: [],
      editionPreviews: [],
    };
  }

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
    } = this.props;

    const { createdOrUploadedPDF, editionPreviews } = this.state;

    if (!entityLoaded) {
      return <LoaderCC />;
    }

    const output = [];
    if (!entity.getOrders().length) {
      output.push(<p>{messages.no_printData}</p>);
    } else {
      const orders = entity.getOrders()[0]; // so richtig sauber ist das nicht
      let filenamePrintData = messages.not_available;
      let linkToPdf = '';
      let pdfLink;
      let previews = [];
      const originalMasterCopy = '';

      if (createdOrUploadedPDF.length > 0) {
        pdfLink = createdOrUploadedPDF;
      } else {
        pdfLink = orders.items[0].masterCopies[0];
      }

      if (pdfLink && pdfLink !== '') {
        const lastIndex = pdfLink.lastIndexOf('/');
        const filename = pdfLink.substring(lastIndex + 1);
        filenamePrintData = filename;
        linkToPdf = pdfLink;
      }

      if (editionPreviews.length > 0) {
        previews = editionPreviews;
      } else {
        previews = orders.items[0]?.edition?.previews;
      }

      output.push(
        <div className="panel panel-transparent">
          <Row>
            <Col md={12}>
              <h3>{messages.content_check}</h3>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div>
                <h4>{messages.preview}</h4>
                <p>
                  <i className="fal fa-file-pdf" />{' '}
                  {previews.map(p => {
                    return <img key={p.id} src={p.key} alt="preview" />;
                  })}
                </p>
                <h5 style={{ color: '#CD1719' }}>{originalMasterCopy}</h5>
              </div>
            </Col>
            <Col md={6}>
              <div>
                <h4>{messages.printDataFiles}</h4>
                <p>
                  <i className="fal fa-file-pdf" />{' '}
                  {pdfLink && (
                    <a href={linkToPdf} target="_blank" rel="noopener noreferrer">
                      {filenamePrintData}
                    </a>
                  )}
                </p>
                <h5 style={{ color: '#CD1719' }}>{originalMasterCopy}</h5>
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    return <div className="clearfix padding-25 sm-padding-10">{output}</div>;
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeadContentCheck)
);
